import { Component, ElementRef, Inject} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from "../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component";
import { OrderRs, CancelRs } from '../../../interfaces/service.response';


@Component({
    selector: "modal-ordernotificationn",
    template: require('./ordernotification.component.html'),
    styles: [require('./ordernotification.component.css')]
})

export class OrderNotificationModal {

    public ticketToCancel?: string;
    private _tradeData:OrderRs|CancelRs = new OrderRs()||new CancelRs();

    set responseData(v:OrderRs|CancelRs)
    {
       console.log("MODAL");
             console.log(v);
        if(v.Currency===undefined)
        { 
            
            this.hideAllItems=true;
        }
        this._tradeData=v;
    }

    get responseData():OrderRs|CancelRs
    {
        return this._tradeData
    }


    private _hideAllItems: boolean = false;
    public get hideAllItems (): boolean {
        return this._hideAllItems;
    }
    public set hideAllItems ( value: boolean ) {
        this._hideAllItems = value;
    }


    get Type():string { 

        return this.responseData.Type
    };
    get Currency():string { return this.responseData.Currency};
    get Quantity():number { return this.responseData.Quantity};
    get Side(): string { return this.responseData.Side};
    get StopPrice():number { return this.responseData.StopPrice};
    get LimitPrice():number { return this.responseData.LimitPrice};
    get Error():string { 

        return this.responseData.Error
    };

    set Type(v:string) { };
    set Currency(v:string) { };
    set Quantity(v:number) {  };
    set Side(v: string) {  };
    set LimitPrice(v:number) {  };
    set StopPrice(v:number) {  };
    set Error(v:string) {  };

    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private dataService: DataService
    ) {

    }

    acceptOrder()
    { 
        this.activeModal.close();
    }

   
}

export function ShowOrderNotificationModal(modalService: NgbModal, responseData:OrderRs|CancelRs){
    let m:NgbModalRef= modalService.open(OrderNotificationModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<OrderNotificationModal>m.componentInstance);
    
    modal.responseData = responseData;

    if(responseData.Type=="OrderRs")
    {
        if(responseData.LimitPrice>0||responseData.StopPrice>0)
        {
          modal.responseData.Type = "Pending";
        }
      
    }
 
    

  //  modal.responseData.Error = "ANY ERROR";
   
    return modal;
}

